export default __webpack_public_path__ + "static/media/giide-create.ba7aa43d.jpg";